﻿window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments) }
gtag("js", new Date);
gtag("config", "UA-2905701-8");
gtag('config', 'UA-72849501-2');


//////////////////
// WEBPACK FOOTER
// ./public/Analytics.js
// module id = 538
// module chunks = 1